export const BUILDER_MODELS = {
  ACCOUNT: 'account',
  MYSTERY_BOX_CONFIG: 'mystery-box-config',
  MYSTERY_BOX_MODAL_DETAILS: 'mystery-box-modal-details',
  MYSTERY_BOX_QUESTION: 'mystery-box-question',
  ACCOUNT_NAVIGATION: 'account-navigation',
  CATEGORY_NAVIGATION: 'category-navigation',
  CATEGORY_PAGE: 'category-page',
  CHECKOUT_INTERSTITIAL_PAGE: 'checkout-interstitial-page',
  COLLECTION_PAGE: 'collection-page',
  EMBROIDERY_CONFIG: 'embroidery-config',
  FOOTER: 'footer',
  HDYH: 'hdyh',
  HEADER: 'header',
  GRID_FILTERS: 'grid-filters',
  LANDING_PAGE: 'landing-page',
  LICENSING_PAGE: 'licensing-page',
  MOBILE_APP_HEADER: 'mobile-app-header',
  OUTLET: 'outlet',
  PAGE: 'page',
  PDP_STORYTELLING: 'pdp-storytelling',
  POINTS_FOR_ACTION_UI: 'points-for-actions-ui',
  PRIVATE_CONFIG: 'private-config',
  QUIZ_CONFIG: 'quiz-config',
  QUIZ_PAGE: 'quiz-page',
  SALE_PAGE: 'sale-page',
  SIZE_GUIDE: 'size-guide',
  SYMBOL: 'symbol',
  VIDEO: 'video',
};
